import { render, staticRenderFns } from "./proses_penilaian_massal.vue?vue&type=template&id=6af9c1b9&"
import script from "./proses_penilaian_massal.vue?vue&type=script&lang=js&"
export * from "./proses_penilaian_massal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports